import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import './Navigation.css'

function Navigation() {
  const { t } = useTranslation()
  const location = useLocation()
  const isLandingPage = location.pathname === '/'
  const isDocsPage = location.pathname.startsWith('/docs')

  return (
    <nav className='navbar'>
      <div className='navbar-container'>
        <div className='navbar-logo'>
          <Link to='/'>
            <img src='/logo.png' alt='Runless Logo' className='logo-image' />
            <div className='logo-text'>
              <span className='logo-main'>Runless</span>
              <span className='logo-subtitle'>{t('branding.byCloudSoft')}</span>
            </div>
          </Link>
        </div>

        {isDocsPage ? (
          <ul className='navbar-menu'>
            <li>
              <Link to='/'>{t('nav.home')}</Link>
            </li>
            <li>
              <Link to='/docs'>{t('nav.documentation')}</Link>
            </li>
          </ul>
        ) : (
          <ul className='navbar-menu'>
            <li>
              {isLandingPage ? (
                <a href='#features'>{t('nav.features')}</a>
              ) : (
                <Link to='/#features'>{t('nav.features')}</Link>
              )}
            </li>
            <li>
              {isLandingPage ? (
                <a href='#pricing'>{t('nav.pricing')}</a>
              ) : (
                <Link to='/#pricing'>{t('nav.pricing')}</Link>
              )}
            </li>
            <li>
              <Link to='/docs'>{t('nav.docs')}</Link>
            </li>
            <li>
              {isLandingPage ? <a href='#about'>{t('nav.about')}</a> : <Link to='/#about'>{t('nav.about')}</Link>}
            </li>
          </ul>
        )}

        <div className='navbar-actions'>
          {isLandingPage ? (
            <>
              {/* hidden until login is available */}
              <span style={{ display: 'none' }}>
                <a href='#login' className='btn btn-text'>
                  {t('nav.login')}
                </a>
              </span>
              <span style={{ display: 'none' }}>
                <a href='#signup' className='btn btn-primary'>
                  {t('nav.getStarted')}
                </a>
              </span>
            </>
          ) : (
            <>
              {/* hidden until login is available */}
              <span style={{ display: 'none' }}>
                <Link to='/#login' className='btn btn-text'>
                  {t('nav.login')}
                </Link>
              </span>
              <span style={{ display: 'none' }}>
                <Link to='/#signup' className='btn btn-primary'>
                  {t('nav.getStarted')}
                </Link>
              </span>
            </>
          )}
        </div>
      </div>
    </nav>
  )
}

export default Navigation
